import type { Profile } from '../types/profile';

export interface FAQItem {
  id: string;
  question: string;
  answer: string;
  profile: Profile;
  keywords: string[];
  relatedArticle?: string;
}

export const faqItems: FAQItem[] = [
  {
    id: 'FAQ-A01',
    question: 'Por onde começo?',
    answer: 'Comece pela tela Hoje. Ela foi criada para orientar a ação mais relevante de acordo com seu momento no Personagrama.',
    profile: 'student',
    keywords: ['começar', 'inicio', 'hoje', 'primeiros passos'],
    relatedArticle: 'A01',
  },
  {
    id: 'FAQ-A02',
    question: 'Por que um componente está bloqueado?',
    answer: 'Pode existir um pré-requisito ainda não concluído. Verifique o componente ou condição anterior necessária antes de interpretar o bloqueio como erro.',
    profile: 'student',
    keywords: ['bloqueado', 'travado', 'prerequisito', 'formacao', 'liberar'],
    relatedArticle: 'A07',
  },
  {
    id: 'FAQ-A03',
    question: 'Eu vejo as notas privadas do Mentor?',
    answer: 'Não. As notas privadas do Mentor não são exibidas ao Aluno / Mentorado. O que precisa ser compartilhado deve aparecer no resumo ou em outro espaço compartilhado da Mentoria.',
    profile: 'student',
    keywords: ['nota privada', 'mentor', 'mentoria', 'privacidade', 'resumo'],
    relatedArticle: 'A12',
  },
  {
    id: 'FAQ-A04',
    question: 'Preciso fazer tudo de uma vez?',
    answer: 'Não. O Personagrama organiza o desenvolvimento em etapas e próximas ações. Use Hoje, sua Jornada, Formações e o Plano para avançar no que estiver disponível e fizer sentido naquele momento.',
    profile: 'student',
    keywords: ['tudo de uma vez', 'ordem', 'sequencia', 'próxima ação', 'hoje'],
    relatedArticle: 'A01',
  },
  {
    id: 'FAQ-A05',
    question: 'Qual é a diferença entre Diagnóstico e Meu Desenvolvimento?',
    answer: 'O Diagnóstico registra uma referência do seu ponto de partida. Meu Desenvolvimento ajuda a acompanhar como competências, objetivos, metas e evolução se comportam ao longo do tempo.',
    profile: 'student',
    keywords: ['diagnóstico', 'meu desenvolvimento', 'diferença', 'resultado', 'evolução'],
    relatedArticle: 'A03',
  },
  {
    id: 'FAQ-A06',
    question: 'Qual é a diferença entre Jornada e Formação?',
    answer: 'A Jornada organiza o caminho entre experiências. A Formação estrutura um programa com Etapas, Componentes, regras, participantes e conclusão. Elas podem trabalhar juntas.',
    profile: 'student',
    keywords: ['jornada', 'formação', 'diferença', 'programa', 'caminho'],
    relatedArticle: 'C03',
  },
  {
    id: 'FAQ-A07',
    question: 'Um componente opcional impede a conclusão da Formação?',
    answer: 'Não. Componentes opcionais podem enriquecer a experiência, mas não bloqueiam a conclusão. A conclusão depende dos componentes obrigatórios necessários.',
    profile: 'student',
    keywords: ['opcional', 'obrigatório', 'conclusão', 'formação', 'componente'],
    relatedArticle: 'A13.1',
  },
  {
    id: 'FAQ-A08',
    question: 'Por que preciso marcar uma aula como concluída?',
    answer: 'A conclusão da aula alimenta o progresso real do Treinamento e pode refletir em Componentes, Etapas, Formações e na próxima ação quando existirem esses vínculos.',
    profile: 'student',
    keywords: ['marcar concluído', 'aula', 'progresso', 'treinamento', 'concluir aula'],
    relatedArticle: 'A10',
  },
  {
    id: 'FAQ-A09',
    question: 'O que meu Mentor pode ver sobre mim?',
    answer: 'O Mentor acessa informações necessárias ao acompanhamento dentro da relação autorizada de Mentoria, como desenvolvimento, Plano, Jornada, Formações, Evidências e sessões conforme as permissões do produto. Ele não recebe acesso a todos os alunos da plataforma.',
    profile: 'student',
    keywords: ['mentor vê', 'acesso mentor', 'privacidade', 'mentorado', 'permissão'],
    relatedArticle: 'A12',
  },
  {
    id: 'FAQ-A10',
    question: 'A conclusão de uma Formação gera certificado?',
    answer: 'Não na versão atual. A conclusão fica registrada no Personagrama, mas a emissão de certificado de Formação não faz parte da versão documentada.',
    profile: 'student',
    keywords: ['certificado', 'formação concluída', 'conclusão', 'diploma'],
    relatedArticle: 'A13.1',
  },
  {
    id: 'FAQ-M01',
    question: 'Posso ver qualquer aluno da plataforma?',
    answer: 'Não. O acesso do Mentor depende da relação de Mentoria autorizada. Você acompanha somente os mentorados vinculados à sua alçada.',
    profile: 'mentor',
    keywords: ['mentorados', 'acesso', 'permissao', 'mentor', 'qualquer aluno'],
    relatedArticle: 'M01',
  },
  {
    id: 'FAQ-M02',
    question: 'Posso alterar a metodologia?',
    answer: 'Não. A metodologia oficial é administrada pelo Owner. O Mentor utiliza essa estrutura como referência no acompanhamento, mas não altera sua definição oficial.',
    profile: 'mentor',
    keywords: ['metodologia', 'competencias', 'owner', 'permissao', 'editar'],
    relatedArticle: 'M03',
  },
  {
    id: 'FAQ-M03',
    question: 'Para que serve a Visão 360 do Mentorado?',
    answer: 'Ela reúne contexto para você compreender o momento do mentorado antes de orientar ou conduzir uma Mentoria. O objetivo é fazer perguntas melhores e priorizar intervenções úteis, não fiscalizar a pessoa.',
    profile: 'mentor',
    keywords: ['visão 360', 'contexto', 'mentorado', 'preparar mentoria', 'acompanhamento'],
    relatedArticle: 'M02',
  },
  {
    id: 'FAQ-M04',
    question: 'O que devo observar ao analisar uma Evidência?',
    answer: 'Observe o que ela realmente demonstra: aplicação prática, comportamento, resultado, especificidade e relação com a competência ou objetivo. Um link ou anexo, sozinho, não comprova desenvolvimento.',
    profile: 'mentor',
    keywords: ['evidência', 'analisar', 'validar', 'resultado', 'habilidade', 'atitude'],
    relatedArticle: 'M08',
  },
  {
    id: 'FAQ-M05',
    question: 'Resumo compartilhado e Nota privada são a mesma coisa?',
    answer: 'Não. O resumo compartilhado registra o que pode ser consultado pelo mentorado. A Nota privada apoia o trabalho interno do Mentor e não é exibida ao Aluno / Mentorado.',
    profile: 'mentor',
    keywords: ['resumo compartilhado', 'nota privada', 'diferença', 'mentoria', 'confidencialidade'],
    relatedArticle: 'M11',
  },
  {
    id: 'FAQ-O01',
    question: 'Formação é um Treinamento maior?',
    answer: 'Não. Uma Formação pode combinar Treinamentos, práticas, Mentorias, Evidências, checkpoints e outros Componentes dentro de Etapas e regras próprias.',
    profile: 'owner',
    keywords: ['formacao', 'treinamento', 'componentes', 'curriculo', 'diferença'],
    relatedArticle: 'O21',
  },
  {
    id: 'FAQ-O02',
    question: 'Pré-requisito é apenas uma indicação?',
    answer: 'Não. O pré-requisito é uma regra real de liberação de Componentes na Formação. Quando não é atendido, o próximo Componente pode permanecer bloqueado.',
    profile: 'owner',
    keywords: ['prerequisito', 'bloqueio', 'liberacao', 'formacao'],
    relatedArticle: 'O29',
  },
  {
    id: 'FAQ-O03',
    question: 'O Mentor pode alterar Competências, Níveis ou Descritores oficiais?',
    answer: 'Não. A estrutura oficial da metodologia é administrada pelo Owner. O Mentor utiliza essas referências no acompanhamento sem alterar a definição metodológica oficial.',
    profile: 'owner',
    keywords: ['mentor', 'competências', 'níveis', 'descritores', 'metodologia', 'permissão'],
    relatedArticle: 'O06',
  },
  {
    id: 'FAQ-O04',
    question: 'Posso reutilizar um Treinamento dentro de uma Formação?',
    answer: 'Sim. Um Treinamento já cadastrado pode ser vinculado como Componente do tipo Treinamento dentro de uma Formação, evitando duplicação desnecessária de conteúdo.',
    profile: 'owner',
    keywords: ['reutilizar treinamento', 'formação', 'componente', 'vincular', 'duplicar'],
    relatedArticle: 'O26',
  },
  {
    id: 'FAQ-O05',
    question: 'Componentes opcionais bloqueiam a conclusão?',
    answer: 'Não. Os Componentes opcionais enriquecem o percurso, mas a conclusão da Formação é determinada pelos Componentes obrigatórios necessários.',
    profile: 'owner',
    keywords: ['opcional', 'obrigatório', 'conclusão', 'formação'],
    relatedArticle: 'O28',
  },
  {
    id: 'FAQ-O06',
    question: 'Como um participante passa a acessar uma Formação?',
    answer: 'Na versão atual, o Owner associa participantes à Formação pelo ambiente administrativo. Essa associação faz parte da autorização; um link direto não substitui a inclusão correta do participante.',
    profile: 'owner',
    keywords: ['participante', 'adicionar participante', 'formação', 'acesso', 'associação'],
    relatedArticle: 'O31',
  },
];
